<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <div class="mod-custom">
          <div class="clse">
            <v-btn icon @click.stop="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-container>
              <v-row class="custom">
                <v-col md="12">
                  <div class="md-tl">
                    <p>Archivos masivos</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    ref="file_features"
                    name="file_features"
                    v-model="form.file_features"
                    counter="50"
                    multiple
                    accept=".csv, .png, .jpg, .jpeg, .doc, .docx, .pdf, .xls, .xlsx"
                    @change="onFileChange"
                    :rules="fieldRules"
                    label="Subir Archivos"
                  ></v-file-input>
                  <div class="win_list">
                    <ul class="list_files">
                      <li v-for="(file, f) in visorFiles" :key="f">
                        <div class="file_massive">
                          <div class="file_massive_copy">
                            <div class="file_massive_name">
                              <p>
                                <b>{{ file.name }}</b>
                              </p>
                            </div>
                            <div class="file_massive_action">
                              <a
                                v-if="flatRemove === false"
                                @click="removeFile(f)"
                                >quitar</a
                              >
                            </div>
                          </div>
                          <div class="file_massive_bar">
                            <v-progress-linear
                              :value="file.status"
                            ></v-progress-linear>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- <p>{{ form.file_features }}</p>
                  <p>{{ arrayViewFile }}</p> -->
                </v-col>
              </v-row>
            </v-container>

            <v-spacer></v-spacer>
            <v-progress-linear
              v-if="loading == true"
              color="orange darken-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
            <div class="ctn_btn_shop">
              <v-btn
                :disabled="!valid"
                depressed
                large
                color="primary"
                @click="validate"
                >Subir Archivo</v-btn
              >
              <v-btn
                :disabled="valid"
                depressed
                large
                color="primary"
                @click="closeBtn"
                >Cerrar</v-btn
              >
            </div>
          </v-form>
        </div>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "FileMassiveNew",
  components: {},
  props: ["visible", "space", "parent"],
  data() {
    return {
      form: {
        name: null,
        file_features: null,
        description: null,
        parent: null,
        space: null,
      },
      loading: false,
      flatRemove: false,
      arrayCompany: null,
      arrayViewFile: [],
      arrayStatus: [],
      valid: true,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],
      search: "",
      itemsCompany: [],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
      }
    });
  },
  updated() {},

  watch: {
    async arrayViewFile(newVal, oldVal) {
      console.log("changed", "new ", newVal, " old", oldVal);
      this.arrayViewFile = await newVal;
    },
    deep: true,
  },
  methods: {
    ...mapActions(["addFile"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.valid = false;
        this.loading = true;
        this.flatRemove = true;
        setTimeout(() => {
          this.register();
        }, 3000);
        //console.log("register");
      }
    },
    removeFile(index) {
      //this.arrayViewFile.splice(index, 1);
      this.form.file_features.splice(index, 1);

      this.$forceUpdate();
    },
    onFileChange(e) {
      this.arrayViewFile = this.form.file_features;
      if (this.form.file_features != null) {
        const file = e;
        //console.log("obj", e);
        for (let i = 0; i < this.arrayViewFile.length; i++) {
          let element = this.arrayViewFile[i];
          element.status = 0;
        }
        //console.log("obj", file);
        this.form.name = file.name;
      } else {
        this.form.name = null;
      }
    },
    closeBtn() {
      this.$refs.form.reset();
      this.loading = false;
      this.valid = true;
      this.$emit("close");
    },
    async register() {
      try {
        // this.data
        this.form.space = this.parent._id;
        this.form.user = this.parent.user;
        this.form.parent = this.parent._id;
        let responsed = null;
        // search array data
        console.log();
        for (let i = 0; i < this.form.file_features.length; i++) {
          let file = await this.form.file_features[i];
          console.log("--", i, file);
          const formData = new FormData();
          formData.append("user", this.form.user);
          formData.append("space", this.form.parent);
          formData.append("parent", this.form.parent);
          formData.append("file_features", file);
          //formData.append("other", file.name);

          // Display the key/value pairs
          for (var pair of formData.entries()) {
            console.log(pair[0] + ", " + pair[1]);
          }
          responsed = await this.addFile(formData);
          console.log("res", responsed);
          this.arrayViewFile[i].status = await responsed;
          this.$forceUpdate();

          //this.updateData();
        }
        console.log("Subir archivo", this.arrayViewFile);
        //this.$refs.form.reset();
        this.loading = false;
        //this.valid = true;
        this.$root.$emit("reload");
        this.$root.$emit("snackbar", {
          status: 200,
          visible: true,
          text: `se han cargado ${this.arrayViewFile.length} archivos`,
        });

        // if (responsed == 200) {
        //   // load
        //   //console.log("creado", responsed);
        //   this.show = false; // parametro update tabla
        // }
      } catch (error) {
        this.$refs.form.reset();
        // load
        this.loading = false;
        this.valid = true;
        //console.log("error catch", error);
        this.$root.$emit("snackbar", {
          status: 404,
          visible: true,
          text: `Ocurrió un error inesperado - ${error}`,
        });
        this.show = false;
      }
    },
  },
  computed: {
    visorFiles() {
      return this.arrayViewFile;
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
.win_list {
  height: 200px;
  overflow-y: scroll;
}
ul.list_files {
  list-style: none;
  margin-left: 0;
  padding-left: 0;
}
.file_massive {
  margin-bottom: 20px;
  .file_massive_copy {
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
    .file_massive_name {
      display: flex;
      flex: 1 1 auto;
      p {
        font-size: 0.9rem;
        margin: 0;
      }
    }
    .file_massive_action {
      margin: 0 10px;
    }
  }
  .file_massive_bar {
  }
}
</style>
